export default __webpack_public_path__ + "static/media/ORA.5869e824.png";